import { createFileRoute } from '@tanstack/react-router'

import PageFolderNew from '@/pages/PageFolderNew'

export const Route = createFileRoute('/folder/new')({
  component: PageFolderNew
})
